<template>
  <div class="performance-edit add-page">
    <div>
      <el-form v-if="form" :model="form" :disabled="true" ref="form" label-width="120px" :hide-required-asterisk="true">
        <div>
          <div>考生基本信息</div>
          <el-form-item label="考生姓名" prop="examineeName">
            {{form.examineeName}}
          </el-form-item>
          <el-form-item label="考生性别" prop="examineeSex">
            {{$enums.sex[form.examineeSex]}}
          </el-form-item>
          <el-form-item label="出生日期" prop="birthday">
            {{form.birthday}}
          </el-form-item>
          <el-form-item label="证件类型" prop="idType">
            {{$enums.idType[form.idType]}}
          </el-form-item>
          <el-form-item label="证件号码" prop="examineeIdNo">
            {{form.examineeIdNo}}
          </el-form-item>
          <template v-if="form.evaluateResult && form.evaluateResult.dimensionResultList">
            <div>考试内容</div>
            <div style="margin-top: 20px;">
              <el-table :data="form.evaluateResult.dimensionResultList" :max-height="330" stripe size="medium">
                <el-table-column prop="dimensionName" label="考核内容项"></el-table-column>
                <el-table-column prop="dimensionValue" label="考核成绩"></el-table-column>
                <el-table-column prop="remarkContent" label="评语"></el-table-column>
              </el-table>
            </div>
          </template>
          <template v-if="form.evaluateResult && form.evaluateResult.evaluateResult">
            <div style="display: flex">
              <div style="margin-top: 20px;">综合成绩:</div>
              <div class="text-center" style="min-height: 30px;color: #666666;margin: 20px 0 0 20px;">
                {{form.evaluateResult.evaluateResult}}
              </div>
            </div>
          </template>
          <template v-if="form.evaluateResult && form.evaluateResult.remarkContent">
            <div style="margin-top: 20px;">综合评语:</div>
            <div class="text-left" style="min-height: 100px;color: #666666;">
              {{form.evaluateResult.remarkContent}}
            </div>
          </template>
          <template v-if="form.evaluateResult && !Tool.isNull(form.evaluateResult.evaluateSign2)">
            <div>考官手签</div>
            <div class="text-left">
              <img v-for="(signUrl,s) in form.evaluateResult.evaluateSign2" :key="'signUrl'+s" style="height: 100px;" :src="signUrl" alt="">
            </div>
          </template>
          <div>发布状态：{{$enums.evaluateStatus2[form.evaluateResult.evaluateStatus]}}</div>
        </div>
      </el-form>
    </div>
    <div class="text-right add-bottom fixed">
      <el-button size="medium" @click="$router.push({path:'./performance',query:$route.query})">返回</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: [],
  data () {
    return {
      form: null
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async initForm () {
      if (this.$route.query.examId) {
        let info = await this.$HTTP.GradeExam.getInfo(this.$route.query.examId)
        if (info.evaluateResult && !this.Tool.isNull(info.evaluateResult.evaluateSignList)) {
          info.evaluateResult.evaluateSign2 = []
          for (let i in info.evaluateResult.evaluateSignList) {
            let signUrl = info.evaluateResult.evaluateSignList[i]
            let signUrl2 = await this.$HTTP.ApiOss.signatureUrl(signUrl, 'exam-data')
            info.evaluateResult.evaluateSign2.push(signUrl2)
          }
        }
        this.form = info
      } else {
        // throw new Error('examId不能为空')
      }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    }
  }
}
</script>
